import type { IconSvgObject } from './types';

const CornerRightDownIcon: IconSvgObject = [
  ["path", { d: "M15 19L15 12C15 8.22876 15 6.34315 13.8284 5.17157C12.6569 4 10.7712 4 7 4L4 4", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M20 15C20 15 16.3176 20 15 20C13.6824 20 10 15 10 15", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default CornerRightDownIcon;
